import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import useGetImages from '../../../../../hooks/use-get-images';
import StatusMessage from '../../../../common/status-message';
const DeniedEnrollment = () => {
    const { t } = useTranslation();
    const { ladyWarning } = useGetImages();
    return (_jsx(StatusMessage, { id: "denied-enrollment", image: ladyWarning, title: t('deniedEnrollment.title') }));
};
export default DeniedEnrollment;
